import { render, staticRenderFns } from "./FollowModal.vue?vue&type=template&id=37f8380a&"
import script from "./FollowModal.vue?vue&type=script&lang=js&"
export * from "./FollowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports